import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const FreshdeskModal = (props) => {
    const {user} = useAppContext();
    const {provider, toggle} = props;
    const [apikey, setApikey] = useState("");
    const [errorApikey, setErrorApikey] = useState(false);
    const [orgurl, setOrgUrl] = useState("");
    const [errorOrgUrl, setErrorOrgUrl] = useState(false);

    const handleSubmit = async (values) => {
        if (!apikey) {
            setErrorApikey(true);
        }

        // normalize url to https://rafiki.myfreshdesk.com/
        let temp = normalizeURL(orgurl);
        let provider = {
            accessToken: apikey,
            url: temp,
            provider: "freshdesk",
            service: "supportDesk",
        }
        try {
            let response = await postJsonAxiosService("freshdesk/webhook/validate", {provider: provider});
            if (response) {

                if (response.data === "Incorrect API key") {
                    toastService.error("Invalid Api Key");
                } else {
                    if (!user.providers || user.providers.length == 0) {
                        user.providers = [];
                    }
                    user.providers.push(provider);
                    toastService.info("Freshdesk Integrated");
                    window.location.reload();
                }
            }
        } catch (e) {
            toastService.error("Error while updating integration");
        }
    };

    function normalizeURL(input) {
        var pattern = /^(https?:\/\/)([^\/]+)(.*)$/;
        var matches = input.match(pattern);
        if (!matches) {
            input = 'https://' + input;
        } else {
            if (!matches[1]) {
                input = 'https://' + input;
            }
            if (!matches[3].endsWith('/')) {
                input = input + '/';
            }
        }
        // if (input.endsWith('crm/sales/') || input.endsWith('crm/sales')) {
        //     input = input.split("crm/sales")[0];
        // }
        if (!input.endsWith('/')) {
            input = input + '/';
        }
        return input;
    }
    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Freshdesk Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <label>Api Key</label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter Api Key"
                               value={apikey}
                               onChange={(e) => {
                                   setApikey(e.target.value);
                                   setErrorApikey(false);
                               }}
                        />
                        {errorApikey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter Api Key
                            </div>
                        ) : null}
                    </div>
                    <div>
                    </div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124", marginTop: 20}}>
                        <label>Organization Url</label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter Organization Url eg. https://getrafiki.myfreshdesk.com/"
                               value={orgurl}
                               onChange={(e) => {
                                   setOrgUrl(e.target.value);
                                   setErrorOrgUrl(false);
                               }}
                        />
                        {errorApikey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter Organization Url in format "https://domain.myfreshdesk.com/"
                            </div>
                        ) : null}
                    </div>

                </div>

            </ModalBody>
            <ModalFooter style={{border: "none", padding: "0px 0px 10px 30px"}}>
                <Button className={"btn-typography-secondary"} onClick={props.toggle}>
                    Cancel
                </Button>{" "}
                <Button className={"btn-typography-primary"} onClick={handleSubmit}>
                    Authorize
                </Button>{" "}
            </ModalFooter>
        </div>
    )
};

export default FreshdeskModal;
